export const socialMediaData = {
    "youtube":{
        "name":"Youtube",
        "coordinates": [4, 2]
    },
    "spotify":{
        "name":"Spotify",
        "coordinates": [0, 3]
    },
    "bandcamp":{
        "name":"Bandcamp",
        "coordinates": [1, 0]
    },
    "soundcloud":{
        "name":"Soundcloud",
        "coordinates": [3, 2]
    },
    "applemusic":{
        "name":"Apple Music",
        "coordinates": [0, 0]
    },
    "tiktok":{
        "name":"Tiktok",
        "coordinates": [1, 3]
    },
    "x":{
        "name":"X",
        "coordinates": [4, 1]
    },
    "instagram":{
        "name":"Instagram",
        "coordinates": [2, 1]
    },
    "discord":{
        "name":"Discord",
        "coordinates": [0, 1]
    },
    "patreon":{
        "name":"Patreon",
        "coordinates": [1, 2]
    },
    "kickstarter":{
        "name":"Kickstarter",
        "coordinates": [3, 1]
    },
    "kofi":{
        "name":"Kofi",
        "coordinates": [0, 2]
    },
    "facebook":{
        "name":"Facebook",
        "coordinates": [1, 1]
    },
    "bilibili":{
        "name":"Bilibili",
        "coordinates": [2, 0]
    },
    "reddit":{
        "name":"Reddit",
        "coordinates": [2, 2]
    },
    "carrd":{
        "name":"Carrd",
        "coordinates": [3, 0]
    },
    "twitch":{
        "name":"Twitch",
        "coordinates": [2, 3]
    }
}

export const socialMediaHome = [
    {slug: "youtube", link: "https://www.youtube.com/@dreamfloweridols/featured"}, 
    {slug: "spotify", link: "https://open.spotify.com/artist/0wcVgcfSEPl1U4Z3yYv1sw?si=vVhpc-csTo2YrWQPZ6UhCw"}, 
    {slug: "bandcamp", link: "https://dreamfloweridols.bandcamp.com/"}, 
    {slug: "soundcloud", link: "https://soundcloud.com/dream-flower-idols"}, 
    {slug: "applemusic", link: "https://music.apple.com/us/artist/dream-flower-idols/1812398730"}, 
    {slug: "tiktok", link: "https://www.tiktok.com/@dreamfloweridols?sender_device=pc"}, 
    {slug: "x", link: "https://twitter.com/dreamfloweridol"}, 
    {slug: "instagram", link: "https://www.instagram.com/dreamfloweridols/"}, 
    {slug: "discord", link: "https://discord.gg/7p6RMbEJeb"}, 
    {slug: "patreon", link: "http://patreon.com/user?u=56274162"}, 
    {slug: "kickstarter", link: "https://www.kickstarter.com/profile/dreamfloweridols"}, 
    {slug: "kofi", link: "https://ko-fi.com/dreamfloweridols"}, 
    // {slug: "facebook", link: ""}, 
    // {slug: "bilibili", link: ""}, 
    // {slug: "reddit", link: ""}, 
]

